import { render, staticRenderFns } from "./SugerenciasDireccion.vue?vue&type=template&id=5b117150&"
import script from "./SugerenciasDireccion.vue?vue&type=script&lang=js&"
export * from "./SugerenciasDireccion.vue?vue&type=script&lang=js&"
import style0 from "./SugerenciasDireccion.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports